import { EthereumStakingValidatorInfo } from '#/data/react-query/queries/order-list';
import React from 'react';
import { InterpreterFrom, assign, createMachine } from 'xstate';

interface MachineContext {
  target: EthereumStakingValidatorInfo;
  sources: EthereumStakingValidatorInfo[] | null;
  isConsolidatableOnly: boolean;
}
const machine = createMachine<MachineContext>({
  predictableActionArguments: true,
  preserveActionOrder: true,
  context: {
    target: null as any as EthereumStakingValidatorInfo,
    sources: null,
    isConsolidatableOnly: true,
  },
  initial: 'source-validators',
  states: {
    'source-validators': {
      on: {
        NEXT: {
          target: 'confirmation',
          actions: assign((context, event) => {
            const { sources } = event.data;
            return { sources };
          }),
        },
        SET_STATE: {
          actions: assign((context, event) => {
            return event.data;
          }),
        },
      },
    },
    confirmation: {
      on: {
        PREV: {
          target: 'source-validators',
        },
      },
    },
  },
});

const MachineContext = React.createContext(
  {} as InterpreterFrom<typeof machine>
);

export { MachineContext };

export default machine;
